import React from 'react';
import { Card, CardContent } from '@/Components/ui/card';
import { Text } from '@/Components/ui/typography';
import { Stack, Grid } from '@/Components/ui/layout';
import { Calendar, Globe, Heart, User, Briefcase, GraduationCap } from 'lucide-react';

function PersonalInfo() {
  const infoItems = [
    { icon: Calendar, label: 'DATE OF BIRTH', value: '14 June, 2021' },
    { icon: Globe, label: 'NATIONALITY', value: 'Indian' },
    { icon: Heart, label: 'MARITAL STATUS', value: 'Single' },
    { icon: User, label: 'GENDER', value: 'Male' },
    { icon: Briefcase, label: 'EXPERIENCE', value: '7 Years' },
    { icon: GraduationCap, label: 'EDUCATION', value: 'Master Degree' }
  ];

  return (
    <Card className="rounded-lg border-[1.5px] border-blue-50 bg-white flex flex-col p-6">
      <CardContent className="p-0">
        <Grid cols={2} gap="md" className="gap-4">
          {infoItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <div key={index} className="flex flex-col w-[124px]">
                <Icon className="w-8 h-8 mb-3 text-slate-600" />
                <Stack spacing="xs">
                  <Text size="xs" className="text-slate-500 font-normal uppercase">
                    {item.label}
                  </Text>
                  <Text size="sm" className="text-slate-900 font-medium leading-none mt-1">
                    {item.value}
                  </Text>
                </Stack>
              </div>
            );
          })}
        </Grid>
      </CardContent>
    </Card>
  );
}

export default PersonalInfo;